export default {
  // 页面标题
  'pages.building.title': 'Building Management',

  // 表格列标题
  'pages.building.table.columns.buildingName': 'Building Name/Code',
  'pages.building.table.columns.buildingType': 'Building Type',
  'pages.building.table.columns.floorCount': 'Floors',
  'pages.building.table.columns.unitCount': 'Units',
  'pages.building.table.columns.totalUnits': 'Total Households',
  'pages.building.table.columns.elevatorCount': 'Elevators',
  'pages.building.table.columns.buildingArea': 'Building Area(㎡)',
  'pages.building.table.columns.buildingHeight': 'Building Height(m)',
  'pages.building.table.columns.constructionYear': 'Construction Year',
  'pages.building.table.columns.completionYear': 'Completion Year',
  'pages.building.table.columns.project': 'Project',
  'pages.building.table.columns.operations': 'Operations',

  // 按钮文本
  'pages.building.buttons.view': 'View',
  'pages.building.buttons.edit': 'Edit',
  'pages.building.buttons.delete': 'Delete',
  'pages.building.buttons.create': 'Create Building',
  'pages.building.buttons.batchDelete': 'Batch Delete',
  'pages.building.buttons.close': 'Close',
  'pages.building.buttons.update': 'Update',
  'pages.building.buttons.createBtn': 'Create',

  // 模态框标题
  'pages.building.modal.createTitle': 'Create Building',
  'pages.building.modal.editTitle': 'Edit Building',
  'pages.building.modal.detailTitle': 'Building Details',

  // 确认对话框
  'pages.building.confirm.delete': 'Are you sure you want to delete this building?',
  'pages.building.confirm.batchDelete': 'Are you sure you want to batch delete the selected buildings?',
  'pages.building.confirm.okText': 'Confirm',
  'pages.building.confirm.cancelText': 'Cancel',

  // 表格选择提示
  'pages.building.table.selection.selected': 'Selected',
  'pages.building.table.selection.items': 'items',
  'pages.building.table.selection.cancel': 'Cancel Selection',

  // 成功/失败消息
  'pages.building.message.loadTypeFailed': 'Failed to load building types',
  'pages.building.message.getDetailFailed': 'Failed to get building details',
  'pages.building.message.deleteSuccess': 'Delete successful',
  'pages.building.message.deleteFailed': 'Delete failed',
  'pages.building.message.batchDeleteSuccess': 'Batch delete successful',
  'pages.building.message.batchDeleteFailed': 'Batch delete failed',
  'pages.building.message.createSuccess': 'Create successful',
  'pages.building.message.updateSuccess': 'Update successful',
  'pages.building.message.createFailed': 'Create failed',
  'pages.building.message.updateFailed': 'Update failed',

  // 详情描述标签
  'pages.building.detail.label.buildingName': 'Building Name/Code',
  'pages.building.detail.label.buildingType': 'Building Type',
  'pages.building.detail.label.floorCount': 'Floors',
  'pages.building.detail.label.unitCount': 'Units',
  'pages.building.detail.label.totalUnits': 'Total Households',
  'pages.building.detail.label.elevatorCount': 'Elevators',
  'pages.building.detail.label.buildingArea': 'Building Area(㎡)',
  'pages.building.detail.label.buildingHeight': 'Building Height(m)',
  'pages.building.detail.label.constructionYear': 'Construction Year',
  'pages.building.detail.label.completionYear': 'Completion Year',
  'pages.building.detail.label.createdTime': 'Created Time',
  'pages.building.detail.label.updatedTime': 'Updated Time',
  'pages.building.detail.label.project': 'Project',
  'pages.building.detail.label.remarks': 'Remarks',

  // 表单字段标签
  'pages.building.form.label.buildingName': 'Building Name/Code',
  'pages.building.form.label.buildingType': 'Building Type',
  'pages.building.form.label.floorCount': 'Floors',
  'pages.building.form.label.unitCount': 'Units',
  'pages.building.form.label.totalUnits': 'Total Households',
  'pages.building.form.label.elevatorCount': 'Elevators',
  'pages.building.form.label.buildingHeight': 'Building Height(m)',
  'pages.building.form.label.buildingArea': 'Building Area',
  'pages.building.form.label.constructionYear': 'Construction Year',
  'pages.building.form.label.completionYear': 'Completion Year',
  'pages.building.form.label.project': 'Project',
  'pages.building.form.label.remarks': 'Remarks',

  // 表单占位符
  'pages.building.form.placeholder.buildingName': 'Please enter building name or code',
  'pages.building.form.placeholder.buildingType': 'Please select building type',
  'pages.building.form.placeholder.floorCount': 'Please enter number of floors',
  'pages.building.form.placeholder.unitCount': 'Please enter number of units',
  'pages.building.form.placeholder.totalUnits': 'Please enter total households',
  'pages.building.form.placeholder.elevatorCount': 'Please enter number of elevators',
  'pages.building.form.placeholder.buildingHeight': 'Please enter building height',
  'pages.building.form.placeholder.buildingArea': 'Please enter building area',
  'pages.building.form.placeholder.constructionYear': 'Please enter construction year',
  'pages.building.form.placeholder.completionYear': 'Please enter completion year',
  'pages.building.form.placeholder.project': 'Please select project',
  'pages.building.form.placeholder.remarks': 'Please enter remarks',

  // 表单验证消息
  'pages.building.form.validation.buildingNameRequired': 'Please enter building name/code',
  'pages.building.form.validation.buildingNameMaxLength': 'Building name length cannot exceed 100 characters',
  'pages.building.form.validation.buildingTypeRequired': 'Please select building type',
  'pages.building.form.validation.floorCountRequired': 'Please enter number of floors',
  'pages.building.form.validation.floorCountMin': 'Number of floors cannot be less than 1',
  'pages.building.form.validation.unitCountMaxLength': 'Unit count length cannot exceed 10 characters',
  'pages.building.form.validation.totalUnitsMaxLength': 'Total households length cannot exceed 10 characters',
  'pages.building.form.validation.elevatorCountMaxLength': 'Elevator count length cannot exceed 10 characters',
  'pages.building.form.validation.buildingHeightMaxLength': 'Building height length cannot exceed 20 characters',
  'pages.building.form.validation.buildingAreaMaxLength': 'Building area length cannot exceed 20 characters',
  'pages.building.form.validation.constructionYearMaxLength': 'Construction year length cannot exceed 10 characters',
  'pages.building.form.validation.constructionYearPattern': 'Please enter a valid year format (e.g.: 2023)',
  'pages.building.form.validation.completionYearMaxLength': 'Completion year length cannot exceed 10 characters',
  'pages.building.form.validation.completionYearPattern': 'Please enter a valid year format (e.g.: 2023)',
  'pages.building.form.validation.remarksMaxLength': 'Remarks length cannot exceed 500 characters',

  // 单位
  'pages.building.units.floor': 'floors',
  'pages.building.units.unit': 'units',
  'pages.building.units.household': 'households',
  'pages.building.units.elevator': 'elevators',
  'pages.building.units.meter': 'm',
};
